import IsdCodeDropdown11 from "./theme11";
import IsdCodeDropdown12 from "./theme12";
export default function IsdCodeDropdown(props) {
  const theme = props.theme;
  switch (theme) {
    case "theme11":
      return <IsdCodeDropdown11 {...props} />;
      case "theme12":
      return <IsdCodeDropdown12 {...props} />;
    default:
      return <IsdCodeDropdown11 {...props} />;
  }
}
